var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgLcirclepCircle = function SvgLcirclepCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "436.313 216.192 8.625 8.492"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440.626 224.684c2.381 0 4.312-1.901 4.312-4.246 0-2.345-1.93-4.246-4.312-4.246-2.382 0-4.313 1.9-4.313 4.246 0 2.345 1.931 4.246 4.313 4.246z",
    fill: "#F2C2C7"
  })));
};
export default SvgLcirclepCircle;